/** Scale command timestamps into elapsed playback time. */
export function playbackTicks(ticks: readonly [number, number][], speed: 1 | 4 | 16): [number, number][] {
  let elapsed = 0;
  return ticks.map(([seq, at], i) => {
    const gap = i === 0 ? 0 : Math.max(0, at - ticks[i - 1][1]) / speed;
    elapsed += speed === 1 ? gap : Math.min(gap, 5000);
    return [seq, elapsed];
  });
}

/** Find the last command reached by the playback clock. */
export function sequenceAt(ticks: readonly [number, number][], elapsedMs: number): number {
  let low = 0;
  let high = ticks.length;
  while (low < high) {
    const mid = Math.floor((low + high) / 2);
    if (ticks[mid][1] <= elapsedMs) low = mid + 1;
    else high = mid;
  }
  return ticks[Math.max(0, low - 1)]?.[0] ?? 0;
}
